export const insureFormInfo = [{
  value: '',
  name: '投保流水号',
  key: 'policyBatchNo'
}, {
  value: '',
  name: '归属客户',
  key: 'customerName'
}, {
  value: '',
  name: '产品名称',
  key: 'insuranceName'
}, {
  value: '',
  name: '发布应用',
  key: 'applicationName'
}, {
  value: '',
  name: '承保单位',
  key: 'unitName'
}, {
  value: '',
  name: '承保机构',
  key: 'agencyName'
}, {
  value: '',
  name: '中介机构',
  key: 'intermediaryName'
}, {
  value: '',
  name: '投保状态',
  key: 'status'
}, {
  value: '',
  name: '创建时间',
  key: 'createAt'
}];
export const insureDetailInfo = [{
  value: '',
  name: '投保状态',
  key: 'policyStatus'
}, {
  value: '',
  name: '创建时间',
  key: 'infoCreateAt'
}, {
  value: '',
  name: '保单号',
  key: 'policyNo'
}, {
  value: '',
  name: '投保时间',
  key: 'createAt'
}, {
  value: '',
  name: '订单号',
  key: 'orderNo'
}, {
  value: '',
  name: '支付时间',
  key: 'paymentAt'
}];
// 失败明细和批量预览
export const failColumn = [{
  slots: {
    title: '产品名称'
  },
  dataIndex: 'name',
  key: 'name',
  align: 'center',
  className: 'td-bg'
}, {
  slots: {
    title: '方案名称'
  },
  dataIndex: 'planName',
  key: 'planName',
  align: 'center',
  className: 'td-bg'
}, {
  slots: {
    title: '操作'
  },
  dataIndex: 'action',
  key: 'action',
  scopedSlots: {
    customRender: 'action'
  },
  align: 'center',
  width: 180,
  className: 'td-bg'
}];
// 方案说明
export const planColumn = [{
  slots: {
    title: '方案名称'
  },
  dataIndex: 'name',
  key: 'name',
  align: 'center',
  customRender: (text, row, index) => {
    return {
      children: text || '—',
      attrs: {
        rowSpan: row.rowSpan
      }
    };
  }
}, {
  slots: {
    title: '保障额度'
  },
  dataIndex: 'amount',
  key: 'amount',
  align: 'center',
  customRender: (text, row, index) => {
    return {
      children: text || '—',
      attrs: {
        rowSpan: row.rowSpan
      }
    };
  }
}, {
  slots: {
    title: '保障权益'
  },
  dataIndex: 'rightsName',
  key: '3',
  align: 'center',
  customRender: (text, row, index) => {
    return {
      children: text || '—'
    };
  }
}, {
  slots: {
    title: '保障金额'
  },
  dataIndex: 'rightsValue',
  key: 'rightsValue',
  align: 'center',
  customRender: (text, row, index) => {
    return {
      children: text || '—'
    };
  }
}, {
  slots: {
    title: '权益说明'
  },
  dataIndex: 'rightsInfo',
  key: 'rightsInfo',
  align: 'center',
  customRender: (text, row, index) => {
    return {
      children: text || '—'
    };
  }
}];
// 产品
export const productionColumn = [{
  slots: {
    title: '产品名称'
  },
  dataIndex: 'name',
  key: 'name',
  align: 'center',
  customRender: (text, row, index) => {
    return {
      children: text || '—'
    };
  }
}, {
  slots: {
    title: '产品类型'
  },
  dataIndex: 'type',
  key: 'type',
  align: 'center',
  scopedSlots: {
    customRender: 'type'
  }
}, {
  slots: {
    title: '方案名称'
  },
  dataIndex: 'planName',
  key: 'planName',
  align: 'center',
  customRender: (text, row, index) => {
    return {
      children: text || '—'
    };
  }
}, {
  slots: {
    title: '保障额度'
  },
  dataIndex: 'amount',
  key: 'amount',
  align: 'center',
  customRender: (text, row, index) => {
    return {
      children: text || '—'
    };
  }
}, {
  slots: {
    title: '保费'
  },
  dataIndex: 'price',
  key: 'price',
  align: 'center',
  customRender: (text, row, index) => {
    return {
      children: text || '—'
    };
  }
}, {
  slots: {
    title: '区域'
  },
  dataIndex: 'areaName',
  key: 'areaName',
  align: 'center',
  customRender: (text, row, index) => {
    return {
      children: text || '—'
    };
  }
}, {
  slots: {
    title: '折扣保费'
  },
  dataIndex: 'discountAmount',
  key: 'discountAmount',
  align: 'center',
  customRender: (text, row, index) => {
    return {
      children: text || '—'
    };
  }
}];
// 查看页面列表
export const infoColumn = [{
  slots: {
    title: '序号'
  },
  dataIndex: 'index',
  scopedSlots: {
    customRender: 'index'
  },
  width: 80,
  align: 'center'
}, {
  slots: {
    title: '保单号'
  },
  dataIndex: 'policyNo',
  key: 'policyNo',
  align: 'center',
  customRender: text => {
    return {
      children: text || '—'
    };
  }
}, {
  slots: {
    title: '个人投保状态'
  },
  dataIndex: 'policyStatus',
  key: 'policyStatus',
  align: 'center',
  scopedSlots: {
    customRender: 'policyStatus'
  }
}, {
  slots: {
    title: '方案名称'
  },
  dataIndex: 'planName',
  key: 'planName',
  align: 'center',
  customRender: text => {
    return {
      children: text || '—'
    };
  }
}, {
  slots: {
    title: '操作'
  },
  dataIndex: 'action',
  key: 'action',
  scopedSlots: {
    customRender: 'action'
  },
  align: 'center',
  width: 100
}];
// index
export const columns = [{
  slots: {
    title: '投保流水号'
  },
  dataIndex: 'batchPolicyNo',
  key: 'batchPolicyNo',
  align: 'center'
}, {
  slots: {
    title: '产品名称'
  },
  dataIndex: 'customerInsuranceName',
  key: 'customerInsuranceName',
  align: 'center'
}, {
  slots: {
    title: '发布应用'
  },
  dataIndex: 'applicationName',
  key: 'applicationName',
  align: 'center'
}, {
  slots: {
    title: '投保状态'
  },
  dataIndex: 'status',
  key: 'status',
  align: 'center',
  scopedSlots: {
    customRender: 'status'
  }
}, {
  slots: {
    title: '创建时间'
  },
  dataIndex: 'createAt',
  key: 'createAt',
  align: 'center'
}, {
  slots: {
    title: '操作'
  },
  dataIndex: 'action',
  key: 'action',
  scopedSlots: {
    customRender: 'action'
  },
  align: 'center',
  width: 200
}];